import './style.css';

import { Drawer } from '@material-ui/core';
import { bind } from 'bind-decorator';
import { Code } from 'bz-core-controls';
import Show from 'bz-core-controls/controls/layout/show';
import _ from 'lodash';
import { observer } from 'mobx-react';
import React from 'react';

import Form from '../../form';
import FormStore from '../../stores/form-store';
import Tab from './controls/tab';

export interface IProps {
  store: FormStore;
}

export interface IState {
  open: boolean;
  menu: number;
  raw: null | object;
}

@observer
class Debugger extends React.Component<IProps, IState> {
  snippet: FormStore;
  summary: FormStore;

  constructor(props: IProps) {
    super(props);
    let { store } = props;

    this.summary = new FormStore(store.controls);
    this.summary.load();

    this.snippet = new FormStore(store.controls);
    this.snippet.load();

    this.state = {
      menu: 1,
      raw: null,
      open: false
    };
  }

  render() {
    const { open, menu } = this.state;
    const { debug, data } = this.props.store;

    if (!debug && !window.debugger) {
      return <span />;
    }

    return (
      <Drawer
        anchor="right"
        classes={{ paper: 'draft-debugger' }}
        docked={true}
        open={open}
        variant="persistent"
        onClose={this.onClose}
      >
        <div className="debugger-tabs">
          <Tab icon="fa-code" selected={menu} value={1} onClick={this.onClick} />
          <Tab icon="fa-database" selected={menu} value={2} onClick={this.onClick} />
          <Tab icon="fa-thumb-tack" selected={menu} value={3} onClick={this.onClick} />
          <Tab icon="fa-scissors" selected={menu} value={4} onClick={this.onClick} />
        </div>
        <div className="debugger-content">
          <Show if={menu === 1}>
            <h4>Template</h4>
            <Code src={this.state.raw} />
          </Show>
          <Show if={menu === 2}>
            <h4>Data</h4>
            <Code src={data} />
          </Show>
          <Show if={menu === 3}>
            <h4>Summary</h4>
            <div className="summary">
              <Form store={this.summary} />
            </div>
          </Show>
          <Show if={menu === 4}>
            <h4>Snippet</h4>
            <Form store={this.snippet} />
          </Show>
        </div>
      </Drawer>
    );
  }

  @bind
  onClick(menu: number): void {
    const { store } = this.props;
    const { raw } = this.state;
    const res: Partial<IState> = { menu: menu, open: true };

    if (menu === 1 && raw === null) {
      res.raw = store.onExport();
    } else if (menu === 3) {
      this.onSummarise();
      const content = store.editor.getCurrentContent();
      const blocks = store.summary.map((key) => {
        return content.getBlockForKey(key);
      });

      // let styleMap = {
      //   'SUMMARY': {display:'block !important', color:'green !important'},
      //   'HIGHLIGHT': {display:'block !important', color:'green !important'}
      // }

      this.summary.loadBlocks(blocks, store.data);
    } else if (menu === 4) {
      // let content = store.editor.getCurrentContent()
      // let blocks = store.snippet.map((key) => {
      //   return content.getBlockForKey(key)
      // })

      this.snippet.loadBlocks(store.snippet, store.data);
    }

    this.setState(res as IState);
  }

  @bind
  onClose(): void {
    this.setState({
      raw: null,
      open: false
    });
  }

  onSummarise(): void {
    const { store } = this.props;
    const { editor } = store;
    const keys: string[] = [];

    const blocks = editor.getCurrentContent().getBlocksAsArray();

    const filter = (x) => {
      return x.hasStyle('SUMMARY') || x.hasStyle('HIGHLIGHT');
    };

    blocks.map((block) => {
      block.findStyleRanges(filter, (start, end) => {
        let path = block.key.split('/');
        path.map((p, i) => {
          keys.push(_.take(path, i + 1).join('/'));
        });
      });
    });

    store.summary = _.uniq(keys);
  }
}

export default Debugger;
